// extracted by mini-css-extract-plugin
module.exports = {"error-section":"error-message_error-section___EUQu","error-image":"error-message_error-image__FFBqF","error-heading-width":"error-message_error-heading-width__soWbD"};